// extracted by mini-css-extract-plugin
module.exports = {"alert":"ContentPage_alert__9CWLX","ContentPage":"ContentPage_ContentPage__iGEN9","regulations":"ContentPage_regulations__2gkmX"};